<div class="my-5">
  <!-- page-header -->
  <sm-page-header [breadcrumb]="breadcrumb" title="settings.refParams.title"></sm-page-header>
  <!-- content -->
  <div class="content">
    <sm-data-table-builder
      [dataTableObject]="dataTableObject"
      [datas]="data"
      [totalRecords]="totalRecords"
      [loading]="loading"></sm-data-table-builder>
  </div>
  <sm-drawer #drawer [drawer]="refParamsDrawer"></sm-drawer>
  <sm-dialog #dialog [dialog]="refParamsDialog"></sm-dialog>
</div>
